import strategyEventConf from './strategyConf'

export const TYPE_MAP = {
  LV1_INFO: 1,
};

class StrategyLog {
  constructor() {
    this.state = {
      lv1_location: '',
      lv1_recid: '',
    }
  }

  strategyDataObj = {
    [TYPE_MAP.LV1_INFO] : {
      get: () => this._getLv1Info(),     
      set: (param) => this._setLv1Info(param),
    }
  }

  getStrategyData(type) {
    return this.strategyDataObj[type]?.get();
  }

  setStrategyData(type, param) {
    return this.strategyDataObj[type]?.set(param);
  }

  getEventStrategyTag(eventId) {
    return strategyEventConf[eventId] || ''
  }

  getLv1Location(param) {
    const {
      l_page, l_componentId, l_pagenum, l_row, l_col, l_position, l_index
    } = param;

    return `${l_page}_${l_componentId}_default_default_default_${l_pagenum}_${l_row}_${l_col}_${l_position}_${l_index}`
  }

  _getLv1Info() {
    const { lv1_location, lv1_recid } = this.state;
    return { lv1_location, lv1_recid }
  }

  _setLv1Info(param = {}) {
    const { lv1_location = '', lv1_recid = '' } = param;
    this.state.lv1_location = lv1_location;
    this.state.lv1_recid = lv1_recid;
  }

}

const strategyLog = new StrategyLog();
export default strategyLog;
